 <template>
    <div class="blured"></div>
	<div class="spinner">
        <img src="../assets/mbiale.png" />
    </div>
</template>

<script>
export default {
  name: 'SpinnerLoader',
  props: {
    msg: String
  }
}
</script>

<style scoped>
.blured {
    z-index:400;
    position: fixed;
    top:0;
    left:0;
    right:0;
    bottom:0;
    background-color:rgba(125,125,125,0.5);
}
.spinner {
    position:fixed;
    width: 40vw;
    height: 40vw;
    background-color:white;
    border-radius: 10px;
    left: 30vw;
    top: calc(50vh - 20vw);
    z-index: 500;
    -webkit-box-shadow: 0px 0px 24px 0px rgba(66, 68, 90, 1);
    -moz-box-shadow: 0px 0px 24px 0px rgba(66, 68, 90, 1);
    box-shadow: 0px 0px 24px 0px rgba(66, 68, 90, 1);
}

.spinner img {
    width:70%;
    margin-top:10%;
    animation: heartbeat 1.5s ease-in-out infinite;
}
@keyframes heartbeat {
    0% {
        transform: scale(1);
    }
    14% {
        transform: scale(1.3);
    }
    28% {
        transform: scale(1);
    }
    42% {
        transform: scale(1.3);
    }
    70% {
        transform: scale(1);
    }
    100% {
        transform: scale(1);
    }
}
</style>
